module.exports = __webpack_public_path__ + "static/media/rust.b76026a3.png";